/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestshowless2Inputs */

const en_requestshowless2 = /** @type {(inputs: Requestshowless2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less`)
};

const de_requestshowless2 = /** @type {(inputs: Requestshowless2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger`)
};

/**
* | output |
* | --- |
* | "Less" |
*
* @param {Requestshowless2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestshowless2 = /** @type {((inputs?: Requestshowless2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestshowless2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestshowless2(inputs)
	return de_requestshowless2(inputs)
});
export { requestshowless2 as "requestShowLess" }